const INFINITE_PREFIX = '$inf$';

export { INFINITE_PREFIX };
